import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/element-primary-green.css'; // 医疗绿主题色覆盖
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import validUtils from './utils/validate.1.0';
import https from './utils/http';
import VueResource from 'vue-resource';
import Pagination from "@/components/common/Pagination";
import RightToolbar from "@/components/common/RightToolbar";
import * as echarts from 'echarts';
import "@/utils/debounce.js"
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
Vue.use(VueResource);
Vue.prototype.$echarts = echarts;
Vue.prototype.$https = https;
console.log(echarts)
// Vue.prototype.$http_get = $http_get;

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ message: msg, type: 'success' })
}
Vue.prototype.msgError = function (msg) {
  this.$message({ message: msg, type: 'error' })
}
Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg)
}

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'zh',
    messages
});
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    const role = localStorage.getItem('ms_username_manage');
    console.log('role', role, to.path)
    if (!role && to.path !== '/login' && to.path !== '/registered' && to.path !== '/route-login') {
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
